import React, { useEffect, useState } from "react";
import AssistantMark from "./AssistantMark";

const THINKING_MESSAGES = [
  "Analyzing your query",
  "Searching the TNS payments knowledge base",
  "Cross-referencing TNS data with general knowledge",
  "Calling Dan, emailing Shannon",
  "Payments is complicated, give me a moment",
  "Thinking deeply, this is taking a bit longer",
  "Formulating a response",
  "Reviewing the response",
];

/**
 * Shown between submitting a question and the first streamed token.
 *
 * Aligned to the assistant column with the same mark, so the answer appears
 * to grow out of this row rather than replacing a centred spinner somewhere
 * else on the page. The rotating copy is decorative and marked
 * aria-hidden — announcing a new phrase every three seconds is noise. A
 * single stable sentence carries the state for assistive tech instead.
 */
export default function ThinkingIndicator() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % THINKING_MESSAGES.length);
    }, 3200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex gap-3 py-1.5 animate-iq-rise">
      <AssistantMark busy />
      <div className="flex min-h-[28px] items-center">
        <span
          aria-hidden="true"
          className="loadingText text-[14px] text-iq-ink-soft"
        >
          {THINKING_MESSAGES[index]}…
        </span>
        <span role="status" className="sr-only">
          Generating a response
        </span>
      </div>
    </div>
  );
}
